// extracted by mini-css-extract-plugin
export default {"prism":"Prism_prism__ule12","postCardContainer":"Prism_postCardContainer__ez3gc","infoBar":"Prism_infoBar__B0UL2"};